import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

// Flag pour éviter les recharges infinies
let hasReloaded = false;

// Gestionnaire global pour les erreurs de chargement de chunks
window.addEventListener('error', (event) => {
  const error = event.error || event.message;
  const isChunkError =
    error?.message?.includes('Failed to fetch dynamically imported module') ||
    error?.message?.includes('Loading chunk') ||
    error?.message?.includes('ChunkLoadError') ||
    event.message?.includes('Failed to fetch dynamically imported module') ||
    event.message?.includes('chunk');

  if (isChunkError && !hasReloaded) {
    // eslint-disable-next-line no-console
    console.warn('[CHUNK LOAD ERROR] Detected chunk loading error, reloading page...', error);
    hasReloaded = true;
    // Recharger la page pour obtenir les nouveaux chunks
    // Utiliser location.reload avec force refresh
    window.location.reload();
    event.preventDefault();
  }
});

// Gestionnaire pour les rejets de promesses non capturés (erreurs async)
window.addEventListener('unhandledrejection', (event) => {
  const error = event.reason;
  const isChunkError =
    error?.message?.includes('Failed to fetch dynamically imported module') ||
    error?.message?.includes('Loading chunk') ||
    error?.message?.includes('ChunkLoadError');

  if (isChunkError && !hasReloaded) {
    // eslint-disable-next-line no-console
    console.warn(
      '[CHUNK LOAD ERROR] Detected chunk loading error in promise, reloading page...',
      error
    );
    hasReloaded = true;
    window.location.reload();
    event.preventDefault();
  }
});

bootstrapApplication(App, appConfig).catch((err) => {
  // Use console.error for critical bootstrap errors
  // eslint-disable-next-line no-console
  console.error('[BOOTSTRAP ERROR]', err);
});
